export const isProdEnvironment = () =>
  ["prod", "production"].includes(process.env.DEPLOY_ENV);

export const isLocalEnvironment = () => "local" === process.env.DEPLOY_ENV;

export const ZOOM_LOGO =
  "https://st1.zoom.us/fe-static/fe-signup-login-active/img/ZoomNewLogo.b2fd5c95.png";

export const goToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
